import { Colors } from "../../styles/colors";
import styles from "./LProgressCircle.module.css";

export const LProgressCircle = ({
    size = 150,
    progress = 0,
    trackWidth = 10,
    trackColor = Colors.darkBlue,
    indicatorWidth = 10,
    indicatorColor = Colors.lightGray,
    indicatorCap = "round",
    label,
    labelColor = Colors.lightGray,
    spinnerMode = false,
    text
}: LProgressCircleProps): JSX.Element => {
    const center = size / 2;
    const radius = center - (trackWidth > indicatorWidth ? trackWidth : indicatorWidth);
    const dashArray = 2 * Math.PI * radius;
    const dashOffset = dashArray * ((100 - progress) / 100);

    const hideLabel = size < 100 || (!label?.length && !text?.length) || spinnerMode;

    return (
        <div className={styles.svgPiWrapper} style={{ width: size, height: size }}>
            <svg className={styles.svgPi} style={{ width: size, height: size }}>
                <circle
                    className={styles.svgPiTrack}
                    cx={center}
                    cy={center}
                    fill="transparent"
                    r={radius}
                    stroke={trackColor}
                    strokeWidth={trackWidth}
                />
                <circle
                    className={`${spinnerMode ? styles.svgPiIndicatorSpinner : ""}`}
                    cx={center}
                    cy={center}
                    fill="transparent"
                    r={radius}
                    stroke={indicatorColor}
                    strokeWidth={indicatorWidth}
                    strokeDasharray={dashArray}
                    strokeDashoffset={dashOffset}
                    strokeLinecap={indicatorCap}
                />
            </svg>
            {!hideLabel && (
                <div className={styles.svgPiLabel} style={{ color: labelColor }}>
                    <span className={styles.svgPiLabelLoading}>{label}</span>

                    {(!spinnerMode || text?.length) && (
                        <span className={styles.svgPiLabelProgress} style={{ color: labelColor }}>
                            {text}
                        </span>
                    )}
                </div>
            )}
        </div>
    );
};

interface LProgressCircleProps {
    size?: number;
    progress?: number;
    trackWidth?: number;
    trackColor?: string;
    indicatorWidth?: number;
    indicatorColor?: string;
    indicatorCap?: "inherit" | "butt" | "round" | "square" | undefined;
    label?: string;
    labelColor?: string;
    spinnerMode?: boolean;
    text?: string;
}
